import React, { memo } from 'react';

type PageTitleProps = {
    title: string;
};

const PageTitle = memo(PageTitleMemo);

function PageTitleMemo({ title }: PageTitleProps) {
    return (
        <div className='card-header page-content-header'>
            <div className='page-content-header-container'>
                <h4>{title}</h4>
            </div>
        </div>
    );
}

export default PageTitle;
